type StorageKey =
  | "desktop.sidebar.collapsed"
  | "desktop.video.collapsed"
  | "mobile.cta.dismissed";

export function set(key: StorageKey, value: boolean) {
  try {
    localStorage.setItem(`biblereader.${key}`, JSON.stringify(value));
  } catch {
    console.error("localStorage.setItem() failed");
  }
}

export function get(key: StorageKey, defaultValue: boolean = false) {
  try {
    return JSON.parse(localStorage.getItem(`biblereader.${key}`)!) as boolean;
  } catch {
    return defaultValue;
  }
}
